/*
 * @Date: 2022-08-22 17:08:32
 * @LastEditors: kinfai
 * @Description: 演示
 * @LastEditTime: 2022-11-03 11:39:23
 * @FilePath: \chatPlugin\src\index.js
 */
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
// import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('wml-web-chat'));

setTimeout(async () => {
    const url = new URL(window.location.href);
    const companyToken = url.searchParams.get("token");
    localStorage.setItem("web-plugin-cc", companyToken)

    const API = 'https://manager-api.needke.com/'
    const defaultConfig = {
        "id": 2,
        "company_id": 1,
        "name": "Needke",
        "status": 1,
        "brand": "needke",
        "brand_icon": API + "/storage/upload/images/company/1/product/2022/09/07/1662538813896746.jpg",
        "background_color": "#4e62b1",
        "button_color": "#1d8dd3",
        "replytime_status": 1,
        "connection": null,
        "created_at": "2022-09-02 14:30:36",
        "updated_at": "2022-09-20 10:23:29",
        "sys_chat": 1,
        "sfid": 406332307092275200,
        "language_type": 2
    }
    async function getCompanyInfo(id = '410330937671286784') {
        const res = await fetch(API + "api/v1/common/chat/channelConf?company_sfid=" + id + "&query_company_set=1"
            + "&t=" + new Date().valueOf()
        )
        const json = await res.json()
        if (json.code === 200) {
            const webPluginConfigKey = `webPluginConfig-${companyToken}`

            if (json.data === null) {
                localStorage.setItem(webPluginConfigKey, JSON.stringify(defaultConfig))
            } else {
                localStorage.setItem(webPluginConfigKey, JSON.stringify(json.data))
            }
        }
        return json
    }

    const companyInfo = await getCompanyInfo(companyToken)
    if (companyInfo.data.chat_channel_enable === 0) {
        console.log("--------web-plugin-disable-------------------------------")
        return false
    }
    console.log("我的token是", companyToken)

    root.render(
        <React.StrictMode>
            <App />
        </React.StrictMode>
    );
}, 0)


// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
